import client from "./client";

const C = "/warehouse/counts";
// جرد المخزون: قائمة · إنشاء · تجميد · تعديل بنود · ترحيل · إلغاء · تصدير Excel · طباعة رسمية
export const listCounts = async (params) => (await client.get(C, { params })).data;
export const createCount = async (body) => (await client.post(C, body)).data;
export const getCount = async (cid) => (await client.get(`${C}/${cid}`)).data;
export const freezeCount = async (cid) => (await client.post(`${C}/${cid}/freeze`)).data;
export const patchCountLines = async (cid, lines) =>
  (await client.patch(`${C}/${cid}/lines`, { lines })).data;
export const submitCount = async (cid, postJe = false) =>
  (await client.post(`${C}/${cid}/submit`, { post_je: postJe })).data;
export const cancelCount = async (cid, reason) =>
  (await client.post(`${C}/${cid}/cancel`, { reason })).data;
export const printCountLink = async (cid) =>
  (await client.post(`/v1/docs/stock_count/${cid}/print-link`)).data;
